module.exports = __webpack_public_path__ + "img/1_001.a5b98517.jpg";